export default __webpack_public_path__ + "static/media/icn_yes.4536a58a.svg";